import React, { useEffect, useMemo, useState } from "react"
import Label from "components/general/Label";
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import Noc from "components/presentation/Noc";
import Competitor from 'components/presentation/Competitor';
import Discipline from 'components/presentation/Discipline';

const getConfiguration = ({ breakPoint, isAlphabeticalSort = true, params }) => {
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        columns: [],
        sortBy: [],
        disableSort: false
    };
    configuration.sortBy = [{ id: 'Competitor', desc: false }, { id: 'NOC', desc: false }, { id: 'Discipline', desc: false }, { id: 'Event', desc: false }];
    configuration.columns = isMobile ? TableColumnsSM({ isAlphabeticalSort, params }) : TableColumns({ isAlphabeticalSort, params })
    return configuration;
};


const CoachesTable = ({ data }) => {
    const { breakPoint } = useViewport();
    const [isAlphabeticalSort, setIsAlphabeticalSort] = useState(true);
    const params = useUrlFriendlyToParameters();
    const config = useMemo(() => getConfiguration({ breakPoint, isAlphabeticalSort, params }), [breakPoint, isAlphabeticalSort, params]);
    useEffect(() => {
        let isAlphabetical = !(data?.some(ath => ath?.disciplines?.some(disc => disc?.descriptionOrder !== 0)));
        setIsAlphabeticalSort(isAlphabetical);
    }, [data]);
    return (

        <MirsTable
            className="table-schedule"
            data={data}
            columns={config.columns}
            keyRow='eventUnit-code'
            initialSortBy={config.sortBy}
            id={`mirs-table-coaches`}
            showPagination={true}
        // pageSizeCustom={10}
        />


    )
}

export default CoachesTable;


function TableColumns({ isAlphabeticalSort = true, params }) {
    return (
        [
            ColumnCompetitor({}),
            ColumnNoc({ params, longDesc: true }),
            ColumnDiscipline({ isAlphabeticalSort }),
            ColumnEvent()
        ]
    )
}

function TableColumnsSM({ isAlphabeticalSort = true, params }) {
    return (
        [
            ColumnCompetitor({}),
            ColumnNoc({ params, longDesc: false }),
            ColumnDiscipline({ isAlphabeticalSort }),
            ColumnEvent()
        ]
    )
}

export function ColumnDiscipline({
    disableSort = false,
    className = 'schedule-discipline text-start',
    headerClassName = 'text-start w-25',
    label = "HeaderDiscipline",
    isAlphabeticalSort = true
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            sortType: isAlphabeticalSort ? 'absoluteOrderString' : 'absoluteOrderNumber',
            accessor: (props) => {
                return isAlphabeticalSort ? props?.disciplines?.find(x => x)?.description?.toLowerCase() : props?.disciplines?.find(x => x)?.descriptionOrder;
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Discipline',
            multiSort: [{ id: 'Discipline' }, { id: 'Event', desc: false }, { id: 'NOC', desc: false }, { id: 'Competitor', desc: false }],
            Cell: (props) => {
                let disciplines = props.cell.row.original?.disciplines;
                return (disciplines?.map((discipline) => <Discipline key={discipline?.code} hasLink={true} code={discipline?.code} description={discipline?.description} />))
            }
        }
    )
}

export function ColumnNoc({ disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start w-25',
    label = 'HeaderTeamNOC',
    remove = false,
    longDesc = true,
    params = {}
}) {

    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'NOC',
            accessor: (props) => props?.organisation?.longDescriptionOrder,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            multiSort: [{ id: 'NOC' }, { id: 'Competitor', desc: false }, { id: 'Discipline', desc: false }, { id: 'Event', desc: false }],
            Cell: (props) => {
                let data = props.cell.row.original?.organisation;
                return (<Noc {...data} showImage={true} showLongDesc={longDesc} hasLink={true} />);
            }
        }
    )

}

export function ColumnCompetitor({
    disableSort = false,
    className = 'schedule-discipline text-start',
    headerClassName = 'text-start w-25',
    label = "LabelName"
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'Competitor',
            accessor: (props) => props.name.toLowerCase(),
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            multiSort: [{ id: 'Competitor' }, { id: 'NOC', desc: false }, { id: 'Discipline', desc: false }, { id: 'Event', desc: false }],
            Cell: (props) => {
                const row = props.cell.row.original
                return (
                    <Competitor {...row} hideNoc={true} hidePicture={false} key={`participant-${row?.code}`} />
                )
            }
        }
    )
}

export function ColumnEvent() {
    return (
        {
            Header: <Label data="LabelEvent" />,
            id: 'Event',
            className: 'schedule-discipline text-start',
            headerClassName: 'text-start',
            disableSortBy: true,
            accessor: (props) => props?.registeredEvents?.at(0)?.event?.order,
            Cell: (props) => {
                const row = props.cell.row.original
                return (
                    <>
                        {row?.registeredEvents?.map((e) => {
                            return (
                                <div key={e?.code}>{e?.event?.longDescription}</div>
                            )
                        })}
                    </>
                )
            }
        }
    )
}


